module.exports = __webpack_public_path__ + "img/youtube_47003.391e872f.png";